module.exports = __webpack_public_path__ + "img/top.9587afe3.png";